import { Session } from "../session/session";


export class Poll {
    session = false;
    pollsChecked = $();

    // staff
    polls;

    constructor() {
        this.init();
    }

    init() {
        this.polls = $('.form-poll');

        if (!this.polls.length) {
            return;
        }

        this.bindEvents();
    }

    bindEvents() {
        this.polls.not(':disabled', this.pollsChecked).on('click', ':radio', (e) => {
            this.submit($(e.delegateTarget));
        });
    }

    fetch(poll) {
        this.ajaxAction(poll, 'GET');
    }

    submit(poll) {
        this.ajaxAction(poll, 'POST');
    }

    // auxiliary
    ajaxAction(poll, method) {
        const session = new Session();

        if (!session.getStatus() || this.session) {
            return;
        }

        const actionUrl = poll.addClass('form-poll--active').prop('action');

        $.ajax({
            url: actionUrl,
            type: method,
            data: {
                option: poll.find(':checked').val()
            }
        })
            .done((res) => {
                if (res.errors.length) {
                    this.showErrorMessage(poll, res.errors);

                    if (res.errors[0].value[0] === 1) {
                        setTimeout(() => {
                            this.redirect();
                        }, 2600);
                    }

                    return;
                }

                this.disable(poll);
                this.pollsChecked.add(poll);
                this.showDoneMessage(poll);

                this.redirect();
            })
            .fail((err) => {
                this.showErrorMessage(poll, err);
            })
            .always(() => {
                poll.removeClass('form-poll--active');
            });
    }

    redirect() {
        const results = $(".lnk-more");
        if (results.length === 1 && results.attr("href") !== undefined) {
            window.location.href = results.attr("href");
        }
    }

    disable(poll) {
        poll.addClass('form-poll--disabled').prop('disabled', true);
    }

    showDoneMessage(poll) {
        const count = poll.find(':checked').closest('.poll-item__action')
            .find('.poll-item__result span');

        count.text(+count.text() + 1);
    }

    showErrorMessage(poll, err) {
        let errorMessage = 'Se ha producido un error desconocido';
        const delay = 3000;

        poll.addClass('form-poll--error');

        // @REDUX
        // add item error
        if (err.length && err[0].value) {
            errorMessage = 'Tu voto ya se ha registrado. No puede votar más de una vez';
        }

        const error = $('<div class="form-item__error"><p>' + errorMessage + '</p></div>');
        const checkedField = poll.find(':checked');

        if (checkedField.closest('.poll-item').length) {
            error
                .insertAfter(checkedField.closest('.poll-item'))
                .fadeOut(delay, () => {
                    $(this).remove();
                });
        } else {
            error
                .appendTo(checkedField.closest('.poll-photo-item'))
                .fadeOut(delay, () => {
                    $(this).remove();
                });
        }
    }
}
